module.exports = __webpack_public_path__ + "img/1543465903.6bb13af5.jpg";